import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { SectionHeader } from '@tribeplatform/react-ui-kit/SectionHeader'
import { Sidebar } from '@tribeplatform/react-ui-kit/Sidebar'

import { SidebarBackButton } from '../../AdminMenu/SidebarBackButton.js'
import { NavigationSidebarEditor } from '../../Editor/Sidebar/index.js'

export function AppearanceNavigationRoute() {
  const { $t } = useI18n()

  return (
    <Sidebar size="lg">
      <Sidebar.Content className="px-3 space-y-4">
        <SidebarBackButton href={adminRoutes.design.appearance.root} />
        <SectionHeader
          title={$t({
            defaultMessage: 'Header and sidebar',
            id: 'Generics.HeaderAndSidebar',
          })}
          description={$t({
            defaultMessage:
              'Adjust layout settings for the Header and Sidebar, controlling their visibility and arrangement site-wide.',
            id: 'AdminPanel.Layout.Description',
          })}
        />
        <NavigationSidebarEditor />
      </Sidebar.Content>
    </Sidebar>
  )
}

export function NavigationBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.design.customizer.navigation}>
      <T id="Generics.Navigation" defaultMessage="Navigation" />
    </Link>
  )
}
